import style from "../AddReview.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import LottieAnimator from "@Components/LottieAnimator";
import useTranslationHook from "hooks/useTranslationHook";
//

const AddReviewFormSuccess = ({ name = "" }: any) => {
  const { t } = useTranslationHook();

  return (
    <div className={formatClassNames(style.reviewForm, style.successReviewForm)}>
      <div className={style.successScreen}>
        <LottieAnimator animationData="Love.json" renderer="svg" id="book-form" />
      </div>
      <div className={style.successTitle}>
        {t("propertypage.reviewssection.addreview.addreviewform.successtitle")}
        {name ? `, ${name}` : ""}!{" "}
      </div>
      <div className={style.successDescription}>
        {t("propertypage.reviewssection.addreview.addreviewform.successdescription")}
      </div>
    </div>
  );
};

export default wrapperHOC(AddReviewFormSuccess, {
  componentName: "AddReviewFormSuccess-ReviewsSection",
  showForChina: true,
});
